import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { switchMap } from 'rxjs/operators';
import { AppStoreSelectors } from 'apps/console/src/app/root-store/app-store';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NewAccountService {
	private http = inject(HttpClient);
	private store = inject(Store);


	chooseSubscription(): Observable<number> {
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.post<number>(`${config.apiUrl}/api/Subsidiaries/choose`, {})),
		);
	}
}
